var messenger = "https://shopfront-cdn.tekoapis.com/static/a8e347d31db4d701.png";

export { messenger as default };
